module.exports = __webpack_public_path__ + "static/media/ly.9acc85f7.svg";